module.exports = __webpack_public_path__ + "img/status2.b781aeec.png";